import { createStore } from "effector";
function status(effect, config) {
  const $status = createStore("initial", config);
  $status.on(effect, () => "pending").on(effect.done, () => "done").on(effect.fail, () => "fail");
  return $status;
}
function viewStatus($status) {
  return {
    $idle: $status.map((status2) => status2 === "initial"),
    $pending: $status.map((status2) => status2 === "pending"),
    $failed: $status.map((status2) => status2 === "fail"),
    $succeeded: $status.map((status2) => status2 === "done"),
    $finished: $status.map((status2) => ["fail", "done"].includes(status2))
  };
}
export {
  status,
  viewStatus
};
//# sourceMappingURL=status.mjs.map
